import React, { useState } from "react";

export const AdditionalGameRounds = () => {
  const [selectedMode, setSelectedMode] = useState(null);

  const gameModes = [
    {
      id: 'lightning',
      title: 'Lightning Round',
      description: 'Answer as many questions as possible in 60 seconds',
      icon: '⚡',
      difficulty: 'Hard',
      rewards: '3x diamonds'
    },
    {
      id: 'artist',
      title: 'Artist Challenge',
      description: 'Test your knowledge about specific artists',
      icon: '🎤',
      difficulty: 'Medium',
      rewards: '2x diamonds'
    },
    {
      id: 'decade',
      title: 'Decade Quiz',
      description: 'Questions from your favorite music era',
      icon: '📻',
      difficulty: 'Easy',
      rewards: '1.5x diamonds'
    },
    {
      id: 'lyrics',
      title: 'Lyrics Master',
      description: 'Complete the missing lyrics',
      icon: '📝',
      difficulty: 'Medium',
      rewards: '2x diamonds'
    }
  ];

  return (
    <div className="additional-game-rounds">
      <div className="additional-rounds-container">
        <div className="rounds-header">
          <h2 className="text-2xl font-bold text-white mb-4">
            Bonus Game Modes
          </h2>
          <p className="text-gray-300 mb-6">
            Choose a special game mode for extra rewards
          </p>
        </div>

        <div className="game-modes-grid">
          {gameModes.map((mode) => (
            <div
              key={mode.id}
              className={`game-mode-card ${selectedMode === mode.id ? 'selected' : ''}`}
              onClick={() => setSelectedMode(mode.id)}
            >
              <div className="mode-icon">{mode.icon}</div>
              <h3 className="mode-title">{mode.title}</h3>
              <p className="mode-description">{mode.description}</p>
              <div className="mode-meta">
                <span className={`difficulty ${mode.difficulty.toLowerCase()}`}>
                  {mode.difficulty}
                </span>
                <span className="rewards">{mode.rewards}</span>
              </div>
              <button className="btn-play-mode">
                Play Now
              </button>
            </div>
          ))}
        </div>

        <div className="daily-challenges">
          <h3 className="text-xl font-semibold text-white mb-4">
            Daily Challenges
          </h3>
          <div className="challenges-list">
            <div className="challenge-item">
              <span className="challenge-icon">🎯</span>
              <div className="challenge-info">
                <p className="challenge-name">Perfect Score</p>
                <p className="challenge-desc">Get 100% accuracy in any round</p>
              </div>
              <span className="challenge-reward">+500 💎</span>
            </div>
            <div className="challenge-item">
              <span className="challenge-icon">🔥</span>
              <div className="challenge-info">
                <p className="challenge-name">Hot Streak</p>
                <p className="challenge-desc">Answer 5 questions correctly in a row</p>
              </div>
              <span className="challenge-reward">+300 💎</span>
            </div>
            <div className="challenge-item">
              <span className="challenge-icon">⏰</span>
              <div className="challenge-info">
                <p className="challenge-name">Speed Demon</p>
                <p className="challenge-desc">Complete a round in under 2 minutes</p>
              </div>
              <span className="challenge-reward">+200 💎</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};